import {useState,useEffect} from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import _debounce from 'lodash/debounce'

const useDebounceSearch = (searchTerm, delay = 1000) => {
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
    useEffect(() => {
      const handler = _debounce(() => {
        setDebouncedSearchTerm(searchTerm);
      }, delay);
      handler();
      // Cleanup function
      return () => {
        handler.cancel();
      };
    }, [searchTerm, delay]);
    return debouncedSearchTerm;
  };

  export default useDebounceSearch